<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="E-Posta"
      label-for="email"
    >
      <b-form-input
        id="email"
        v-model="itemData.translate.email"
        placeholder="E-Posta"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.email }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Adres"
      label-for="address"
    >
      <b-form-textarea
        id="address"
        v-model="itemData.translate.address"
        placeholder="Adres"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.address }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Yol Tarifi Bağlantısı"
      label-for="direction_url"
    >
      <b-form-input
        id="direction_url"
        v-model="itemData.translate.direction_url"
        placeholder="Yol Tarifi Bağlantısı"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.direction_url }}
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BFormTextarea, BAlert, BButton,
} from 'bootstrap-vue'

export default {
  name: 'Hero',
  components: {
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BAlert,
    BButton,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
